<template>
    <div class="w100p">
        <v-text-field 
            append-icon="attach_file" 
            single-line
            v-model="filename" 
            :label="label" 
            :required="required"
            :disabled="disabled"
            ref="fileTextField"
            readonly
            :persistent-hint="persistent_hint"
            :hint="hint"
        ></v-text-field>
        <input 
            type="file" 
            :accept="accept" 
            :multiple="multiple" 
            :disabled="disabled"
            ref="fileInput" 
            @change="onFileChange"
        >
        <v-btn class="ml-0" small raised @click="onPickFile" v-if="!blobUrl">
            Seleziona
        </v-btn>
        <div v-else class="flex">
            <div v-if="showPreview" @click="openFile" class="cursor-pointer">
                <img v-if="['jpg', 'jpeg', 'png', 'gif'].indexOf(fileExt) > -1"
                    :src="blobUrl"
                    height="100"
                    max-width="250"
                    class="cursor-pointer mr25i"
                />
                <div v-else
                    :style="'background-image: url(/images/' + fileExt + '.svg); width: 80px; height: 80px;'"
                ></div>
            </div>
            <div class="margin-auto ml0i">

                <v-btn small raised class="error ml0i" @click="removeFile">
                    Rimuovi
                </v-btn>
            </div>
        </div>
    </div>
</template>
<script>
export default{
	name: 'input-file',
	props: {
		value: {
			type: [Object]
		},
		accept: {
			type: String,
			default: '*'
		},
		label: {
			type: String,
			default: 'Please choose...'
		},
		required: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},            
		persistent_hint: {
			type: Boolean,
			default: false
		},           
		hint: {
			type: String,
			default: ''
		},
		multiple: {
			type: Boolean, // not yet possible because of data
			default: false
		},
		showPreview: {
			type: Boolean,
			default: true
		},
		fieldKey: {
			type: String,
			default: ''
		}
	},

	data(){
		return {
			filename: '',
			imageUrl: '',
			fileExt: '',
			blobUrl: ''
		}
	},

	watch: {
		value(f){
			this.filename = f.original_file_name
			this.fileExt = f.extension
			this.imageUrl = f.path_api

		}
	},

	mounted() {
		if(this.value) {
			this.filename = this.value.original_file_name
			this.fileExt = this.value.extension
			this.imageUrl = this.value.path_api

			if(_.startsWith(this.imageUrl, 'data:')) {
				this.blobUrl = this.imageUrl
			} else {
				this.$eventBusUtility.getFile(this.$store, this.imageUrl, this.filename, true).then(resp => {
					this.blobUrl = resp
				})
			}
		}
	},

	methods: {
		onPickFile() {
			this.$refs.fileInput.click()
		},

		getFormData(files){
			const data = new FormData()
			for (let file of files) {
				data.append('files[]', file, file.name)
			}
			return data
		},

		onFocus(){
			if (!this.disabled) {
				this.$refs.fileInput.click()
			}
		},

		onFileChange($event){
			const files = $event.target.files || $event.dataTransfer.files
			const form = this.getFormData(files)
			if (files) {
				if (files.length > 0) {
					this.filename = [...files].map(file => file.name).join(', ')
				} else {
					this.filename = null
					this.fileExt = ''
				}

				const fileReader = new FileReader()
				fileReader.addEventListener('load', () => {
					this.imageUrl = this.blobUrl = fileReader.result
					this.$emit('input', {'original_file_name': this.filename, 'path_api': this.imageUrl, 'extension': this.fileExt})
					this.$emit('formData', form, this.fieldKey)
				})
				fileReader.readAsDataURL(files[0])
				this.fileExt = files[0].name.split('.').pop().toLowerCase()

			} else {
				this.filename = $event.target.value.split('\\').pop()
			}
		},

		removeFile() {
			this.imageUrl = ''
			this.blobUrl = ''
			this.filename = ''
			this.fileExt = ''
			this.$refs.fileInput.value = ''
			this.$emit('formData', null, this.fieldKey)
		},

		openFile() {
			this.$eventBusUtility.getFile(this.$store, this.imageUrl, this.filename)
			// window.open(this.imageUrl, '_blank');
		},
	}
}
</script>
<style scoped>
    input[type=file] {
        position: absolute;
        left: -99999px;
    }
</style>